import { paymentReleaseActionLabels } from 'src/constants/invoice/constants'
import type { PartnerInvoice, PendingPaymentReleaseAction } from 'src/interfaces/invoice'
import type { MenuActionItem } from 'src/interfaces/ui'
import { getPaymentReleaseActions } from 'src/utils/invoicePaymentRelease'
import { getPartnerInvoiceLabel } from 'src/utils/invoiceLabels'

/**
 * The hold's menu entries for one partner invoice, shared by the partner and composed actions
 * cells. A disabled entry stays visible with its reason as a tooltip, so a `processing` hold
 * explains itself instead of the options silently disappearing.
 */
export const buildPaymentReleaseMenuItems = (
  invoice: PartnerInvoice,
  composedInvoiceLabel: string,
  onPaymentReleaseAction: (action: PendingPaymentReleaseAction) => void,
): MenuActionItem[] => {
  return getPaymentReleaseActions(invoice).map((option) => {
    return {
      label: paymentReleaseActionLabels[option.kind],
      disabled: option.disabledReason !== undefined,
      disabledReason: option.disabledReason,
      dataTestId: `payment-release-${option.kind}-${invoice.id}`,
      onClick: () => {
        onPaymentReleaseAction({
          kind: option.kind,
          partnerInvoice: invoice,
          invoiceLabel: getPartnerInvoiceLabel(invoice),
          composedInvoiceLabel,
        })
      },
    }
  })
}
